
export enum ActionDtoType {
    "MAKE_BID" = "MAKE_BID",
    "CANCEL_BID" = "CANCEL_BID",
    "EDIT_BID" = "EDIT_BID",
    "UPDATE_BID" = "UPDATE_BID",
    "EDIT_TENDER" = "EDIT_TENDER",
    "VIEW_COMPARATIVE_TABLE" = "VIEW_COMPARATIVE_TABLE",
    "VIEW_PROPOSALS" = "VIEW_PROPOSALS",
    "VIEW_POSITIONS" = "VIEW_POSITIONS",
    "UPLOAD_DOCUMENT" = "UPLOAD_DOCUMENT",
    "START_REBIDDING" = "START_REBIDDING",
    "EDIT_REBIDDING" = "EDIT_REBIDDING",
    "FORBIDDEN_START_REBIDDING" = "FORBIDDEN_START_REBIDDING",
    "CANCEL_PARTICIPATION" = "CANCEL_PARTICIPATION"
}
export type ActionDto = {
    /**
     * @type string
    */
    type: ActionDtoType;
    /**
     * @type string
    */
    text: string;
};
